import Step12 from './Step12-compose';

export default Step12;
